import { render, staticRenderFns } from "./AddDiscountModal.vue?vue&type=template&id=0ac8f463&"
import script from "./AddDiscountModal.vue?vue&type=script&lang=js&"
export * from "./AddDiscountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports